import React, { useEffect } from "react";
import { TextInput } from "react-materialize";
import Func from "utils/Func";
import { useNotify } from "context/NotifyContext";

export default function FilterSearch() {
  const { filters, storeFilters } = useNotify();
  const filterName = "search";

  let handleEvents = {
    OnChange: function (evt) {
      if (evt.target.value.length >= 3 || evt.target.value.length === 0) {
        // console.log(evt.target.value);
        storeFilters({
          ...filters,
          search: evt.target.value,
          keyChange: Func.GetKeyRandom(),
        });
      }
    },
  };

  useEffect(() => {}, []);

  return (
    <div
      id={"filter-" + filterName}
      key={"filter-" + filterName + "-" + filters.keyChange}
      className="filter-input-field"
      style={{ marginTop: "15px" }}
    >
      <TextInput
        //icon={<Icon>search</Icon>}
        placeholder=""
        id="filter-inp-search"
        name="search"
        label="IDU or Name or Email Search"
        onChange={handleEvents.OnChange}
        defaultValue={filters?.search ?? ""}
      />
    </div>
  );
}
